import { Box as MuiBox, type BoxProps as MuiBoxProps } from '@mui/material'

export type IBoxProps = MuiBoxProps

export const Box = MuiBox
